import styled from "styled-components"

export const TypesContainerDiv = styled.div`
  display: flex;
  flex-direction: column;
  width: 22rem;
  gap: 1.25rem;
  font-size: 1.4rem;
`

export const WeaknessesAndTypesDiv = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
`

export const CardContainerDiv = styled.div`
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
`
